/* eslint-disable */
export const user = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Brian Hughes',
    email : 'hughes.brian@company.com',
    avatar: 'https://www.theirishfield.ie/WEBFILES/000/537/908/1466125-537908.jpg',
    background: 'https://wallpapers.com/images/featured/baseball-field-background-5rtbkwderzw4et04.jpg',
    status: 'online',
};
